var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LedOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 34.48h-5v-9a8 8 0 00-16 0v9h-5v11h6v11h4v-11h6v11h4v-11h6v-11zm-17-9a4 4 0 118 0v9h-8v-9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_LED_off.99a5d4e7.svg";
export { SvgA3LedOff as ReactComponent };